import { FC, ReactNode, useEffect } from "react";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";

import { useConfirmTikTokIntegrationAuthMutation } from "./api/integrationsAPI";
import { useAppSelector } from "./redux/hooks";

type AppWrapperProps = {
	children: ReactNode;
};

const AppWrapper: FC<AppWrapperProps> = ({ children }) => {
	const user = useAppSelector((state) => state.auth.user);

	const intl = useIntl();

	const [confirmTikTokAuth] = useConfirmTikTokIntegrationAuthMutation();

	useEffect(() => {
		const cookies = new Cookies();
		const tiktokAuthData = cookies.get("tiktokAuthData");

		if (tiktokAuthData && user) {
			const { appKey, code, locale, shopRegion } = tiktokAuthData;
			const domain = window.location.hostname
				.split(".")
				.slice(-2)
				.join(".");

			confirmTikTokAuth({
				app_key: appKey,
				code: code,
				locale: locale,
				shop_region: shopRegion,
			}).then((res) => {
				if ("error" in res) {
					toast.error(
						intl.formatMessage({
							id: "somethingWentWrongWhileConfirmingTikTokIntegration",
						})
					);
				} else {
					toast.success(
						intl.formatMessage({
							id: "successfullyConfirmedTikTokIntegrationYouCanNowSeeItInYourIntegrationsListInSettings",
						})
					);
				}
				cookies.remove("tiktokAuthData", {
					path: "/",
					domain: domain,
				});
			});
		}
	}, [confirmTikTokAuth, user, intl]);

	return <>{children}</>;
};

export default AppWrapper;
